import { ResultadoPrestacaoContaPontuacao } from "./resultado-prestacao-conta-pontuacao.model";

export class ResultadoPrestacaoConta {
    public id: number;
    public id_prestacao_conta: number;
    public id_funcao_exercida: number;
    public resultado_final: string;
    public classe: string = "ResultadoPrestacaoContaDto";

    public resultado_prestacao_conta_pontuacao: ResultadoPrestacaoContaPontuacao[];
}


// WEBPACK FOOTER //
// ./src/app/entity/resultado-prestacao-conta.model.ts